function Anchors(opts) {
	var hash = window.top.location.hash.substr(1);

	var defaults = {
		anchorSelector: 'a[href^="#"]',
	}

	if (!opts) opts = {};
	opts = $.extend(defaults, opts);

	// Remove links that don't actually link to anything
	var anchors = $(opts.anchorSelector).not('[href="#"]').not('[href="#0"]').not('.modaal_trigger');

	var triggerAnchor = function(e, target){
		// Does a scroll target exist?
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - 230
			}, 1000, function() {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
			});
		}
	}

	if(hash){
		var target = $('[id=' + hash + ']');
		target.closest('.wysiwyg_content').show();
		triggerAnchor('', target);
	}

	anchors.click(function(e) {
		// Figure out element to scroll to
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		e.preventDefault();

		triggerAnchor(e, target);
	});

	//on back to top link click scroll to top of page
	$('.back_to_top').click(function(e){
		e.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, 1000);
	});
}